function initProductCards(){
  // Always inject shared blog styles (quote cards, summary grid etc.)
  var style = document.createElement('style');
  style.textContent = [
    '.ipc{display:flex;align-items:center;gap:12px;background:#F1EEEA;border-radius:12px;padding:12px 14px;margin:20px 0;font-family:"Albert Sans",sans-serif}',
    '.ipc a,.ipc a:hover,.ipc a:visited,.ipc a:active{text-decoration:none!important;border:none!important;box-shadow:none!important;background-image:none!important}',
    '.ipc__img{width:56px;height:56px;border-radius:8px;object-fit:cover;background:#fff;flex-shrink:0;display:block}',
    '.ipc__info{flex:1;min-width:0}',
    '.ipc .ipc__name{font-family:"Albert Sans",sans-serif;font-weight:900!important;font-size:18px!important;color:#1a1a1a;line-height:1.2;margin:0;display:block}.ipc .ipc__name a{color:#1a1a1a;text-decoration:none!important;font-weight:900!important;font-size:18px!important;font-family:"Albert Sans",sans-serif;line-height:1.2}',
    '.ipc__variants{display:flex;gap:5px;margin-top:4px;flex-wrap:wrap}',
    '.ipc__pill{font-size:11px;padding:3px 10px;border-radius:20px;border:1px solid #ccc;color:#555;background:#fff;cursor:pointer;line-height:1.4;transition:all .15s ease;display:inline-block;text-transform:uppercase}',
    '.ipc__pill.active{background:#1a1a1a;color:#fff;border-color:#1a1a1a}',
    '.ipc__right{text-align:right;flex-shrink:0}',
    '.ipc__price{font-family:"Albert Sans",sans-serif;font-weight:900;font-size:18px;color:#1a1a1a;white-space:nowrap}',
    '.ipc__atc{display:inline-block;margin-top:4px;background:#2D8A47;color:#fff!important;border:none;border-radius:6px;padding:5px 12px;font-family:"Albert Sans",sans-serif;font-size:13px;font-weight:700;cursor:pointer;transition:background .15s ease;text-decoration:none!important;letter-spacing:0.02em}',
    '.ipc__atc:hover{background:#226B37}',
    '@media (orientation:landscape){.ipc{max-width:350px}}',
    '.ipc-summary-grid{display:flex;flex-wrap:wrap;gap:16px;margin:16px 0}',
    '.ipc-summary-grid .ipc{flex:1 1 calc(50% - 8px);max-width:calc(50% - 8px);box-sizing:border-box;margin:0}',
    '@media (max-width:600px),(orientation:portrait){.ipc-summary-grid .ipc{flex:1 1 100%;max-width:100%}}'
  ].join('\n');
  document.head.appendChild(style);

  var cards = document.querySelectorAll('[data-product-card]');
  if (!cards.length) return;

  var CURRENCY_SYMBOLS = {
    'USD':'$','AUD':'$','SGD':'$','NZD':'$','CAD':'$','HKD':'$','TWD':'$',
    'GBP':'£','EUR':'€','AED':'د.إ','SAR':'﷼','KWD':'KD','BHD':'BD','QAR':'QR','OMR':'OMR',
    'JPY':'¥','CNY':'¥','KRW':'₩','INR':'₹','THB':'฿','MYR':'RM','IDR':'Rp','PHP':'₱',
    'CHF':'CHF','SEK':'kr','NOK':'kr','DKK':'kr','ZAR':'R','BRL':'R$','MXN':'MX$'
  };
  function getCurrencySymbol() {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return CURRENCY_SYMBOLS[code] || code + ' ';
  }
  function formatPrice(priceStr) {
    var num = parseFloat(priceStr);
    var sym = getCurrencySymbol();
    if (isNaN(num)) return sym + '0';
    return sym + num.toFixed(2);
  }

  cards.forEach(function(el) {
    var handle = el.getAttribute('data-product-card');
    if (!handle) return;

    fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var p = data.product;
        if (!p) return;

        var v = p.variants[0];
        var imgSrc = '';
        if (v.featured_image) {
          imgSrc = v.featured_image.src;
        } else if (p.image && p.image.src) {
          imgSrc = p.image.src;
        } else if (p.images && p.images.length) {
          imgSrc = p.images[0].src;
        }
        if (imgSrc) imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2');

        var pillsHtml = '';
        if (p.variants.length > 0) {
          pillsHtml = '<div class="ipc__variants">';
          p.variants.forEach(function(variant, i) {
            var activeClass = i === 0 ? ' active' : '';
            var vImg = '';
            if (variant.featured_image) {
              vImg = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2');
            }
            pillsHtml += '<span class="ipc__pill' + activeClass + '" data-vid="' + variant.id + '" data-price="' + variant.price + '"';
            if (vImg) pillsHtml += ' data-img="' + vImg + '"';
            pillsHtml += '>' + variant.title.replace(/\s*\(.*?\)/g, '') + '</span>';
          });
          pillsHtml += '</div>';
        }

        el.innerHTML =
          '<a href="/products/' + handle + '" style="flex-shrink:0">' +
            '<img class="ipc__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" />' +
          '</a>' +
          '<div class="ipc__info">' +
            '<h3 class="ipc__name"><a href="/products/' + handle + '">' + p.title + '</a></h3>' +
            pillsHtml +
          '</div>' +
          '<div class="ipc__right">' +
            '<div class="ipc__price">' + formatPrice(v.price) + '</div>' +
            '<form method="post" action="/cart/add">' +
              '<input type="hidden" name="id" value="' + v.id + '" />' +
              '<button type="submit" class="ipc__atc">Add +</button>' +
            '</form>' +
          '</div>';

        el.className = 'ipc';

        // Wire up pill clicks
        var pills = el.querySelectorAll('.ipc__pill');
        var priceEl = el.querySelector('.ipc__price');
        var vidInput = el.querySelector('input[name="id"]');
        var imgEl = el.querySelector('.ipc__img');

        pills.forEach(function(pill) {
          pill.addEventListener('click', function() {
            pills.forEach(function(p) { p.classList.remove('active'); });
            this.classList.add('active');
            priceEl.innerHTML = formatPrice(this.dataset.price);
            vidInput.value = this.dataset.vid;
            if (this.dataset.img && imgEl) imgEl.src = this.dataset.img;
          });
        });

        // Wire up add to cart — use theme's mini-cart drawer
        var form = el.querySelector('form');
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var btn = form.querySelector('.ipc__atc');
          if (btn.classList.contains('ipc__loading')) return;
          btn.classList.add('ipc__loading');
          btn.textContent = 'Adding...';

          var miniCart = document.querySelector('mini-cart');
          var payload = {
            items: [{id: parseInt(vidInput.value), quantity: 1}],
            sections: miniCart && miniCart.getSectionsToRender ? miniCart.getSectionsToRender().map(function(s) { return s.id; }) : [],
            sections_url: window.location.pathname
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
          })
          .then(function(r) { return r.json(); })
          .then(function(response) {
            if (response.status) {
              btn.textContent = 'Error';
              setTimeout(function() { btn.textContent = 'Add +'; btn.classList.remove('ipc__loading'); }, 1500);
              return;
            }
            try {
              if (miniCart && miniCart.renderContents) {
                miniCart.renderContents(response);
              }
            } catch(err) { console.warn('IPC: mini-cart render error', err); }
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: vidInput.value });
              }
            } catch(err) {}
            btn.textContent = 'Added ✓';
            btn.style.background = '#226B37';
            setTimeout(function() {
              btn.textContent = 'Add +';
              btn.style.background = '';
              btn.classList.remove('ipc__loading');
            }, 1500);
          })
          .catch(function(err) {
            console.warn('IPC: add to cart error', err);
            btn.textContent = 'Error';
            setTimeout(function() { btn.textContent = 'Add +'; btn.classList.remove('ipc__loading'); }, 1500);
          });
        });
      })
      .catch(function(err) {
        console.warn('IPC: Failed to load product "' + handle + '"', err);
      });
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductCards);
} else {
  initProductCards();
}

// Group consecutive blog-quote-cards into a grid for landscape 2-col layout
function groupQuoteCards() {
  var cards = Array.from(document.querySelectorAll('.blog-quote-card'));
  if (!cards.length) return;

  var i = 0;
  while (i < cards.length) {
    var group = [cards[i]];
    var next = cards[i].nextElementSibling;
    while (next && next.classList.contains('blog-quote-card')) {
      group.push(next);
      next = next.nextElementSibling;
    }
    if (group.length >= 2) {
      var grid = document.createElement('div');
      grid.className = 'blog-quote-grid';
      cards[i].parentNode.insertBefore(grid, cards[i]);
      group.forEach(function(card) { grid.appendChild(card); });
    }
    i += group.length;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  groupQuoteCards();
});
